<template>
  <div class="calendar-split-screen" v-if="$ready_goals">
    <div
      :class="[
        'calendar-split-content',
        'animated-sidebar',
        'scroll-container',
        layout_css_class
      ]"
      v-show="!hide_sidebar">

      <!-- <router-view name="header"/> -->

      <keep-alive :include="cachedViews" :key="contentHashKey">
        {{contentHashKey}}
        <router-view @layout="onChangeLayout"/>
      </keep-alive>

    </div>
    <el-button v-if="!hide_calendar && show_button_sidebar" @click="hide_sidebar = !hide_sidebar" class="seperator-button" v-tooltip="{ content: 'show/hide calendar' }">
      {{hide_sidebar ? '&rarr;' : '&larr;'}}
    </el-button>
    <div
      :class="[
        'calendar-container',
        'animated-sidebar',
        layout_css_class
      ]"
      v-show="!hide_calendar">
      <!-- can grow and shrink -->
      <!-- shows list optionally -->

      <!--
      <template v-if="show_calendar_view_buttons">
        <el-button-group class="m-2 mb-4">
          <el-button :type="selected_calendar_view == 1 ? 'primary' : 'secondary'" @click="onSelectView(1)">Sessions</el-button>
          <el-button :type="selected_calendar_view == 2 ? 'primary' : 'secondary'" @click="onSelectView(2)">Calendar</el-button>
        </el-button-group>
      </template>
      -->

      <!-- <el-checkbox v-show="layout_css_class === 'wide'" v-model="hide_sidebar">hide</el-checkbox> -->
      <!-- <pre>selected_calendar_view: {{selected_calendar_view}}, hide_sidebar: {{hide_sidebar}}</pre> -->

      <keep-alive>
        <!--
        <div v-if="selected_calendar_view === 1">
          <Sessions height="calc(100vh - 177px)" />
        </div>
        <div v-else-if="selected_calendar_view === 2" >
          <Calendar ref="goalcalendar" @auto-update="onOptimize()" />
        </div>
        -->
        <!-- TODO: Calendar load delay -->
        <!-- INFO: Careful when adding new items, must use v-else-if ! -->
        <Calendar v-if="$ready_commitments" ref="goalcalendar" @auto-update="onOptimize()" />
      </keep-alive>

    </div>
    <el-button v-if="!hide_sidebar && show_button_calendar" @click="hide_calendar = !hide_calendar" class="seperator-button" v-tooltip="{ content: 'show/hide sidebar' }">
      {{hide_calendar ? '&rarr;' : '&larr;'}}
    </el-button>
  </div>
</template>

<script>
import Calendar from "@/components/CalendarPage/Calendar"
// import Sessions from "@/components/Sessions/Sessions"
import { mapReady } from '@/api/misc'

const log = (...args) => {} // console.log(...args)

export default {
  data: () => ({
    // show_calendar_view_buttons: true,
    selected_calendar_view: 1,
    layout_css_class: 'narrow',
    hide_sidebar: false, // TODO: Save to app-store
    hide_calendar: true, // TODO: Save to app-store
    last_layout: null
  }),
  computed: {
    ...mapReady('goals', 'commitments'),
    // ...mapGetters("app",[
    //   "calendar_view"
    // ]),
    cachedViews() {
      return [
        'MyDay_Subpage',
        'MyDailyPriorities_Subpage',
        'ManageTimeSubpage',
        'ManageWeekSubpage'
      ];
    },
    contentHashKey() {
      return Object.values(this.$route.params).join('-')
    },
    show_button_calendar() {
      return (this.$route.meta.buttons || []).includes('calendar');
    },
    show_button_sidebar() {
      return (this.$route.meta.buttons || []).includes('sidebar');
    }
  },
  created() {
    log("[layout:calendar] new layout created", this.$route.meta.calendarLayout);
    // this.layout_css_class = this.$route.meta.calendarLayout;
    // this.onChangeLayout( this.layout_css_class )
    this.onRouteChange( this.$route )
  },
  watch: {
    $route (to, from) {
      if ( to.meta.calendarLayout !== from.meta.calendarLayout ) {
        log("[layout:calendar] route change detected");
        this.onRouteChange( to )
      }
    }
  },
  methods: {
    // ...mapActions("app",[
    //   'toggleCalendarViewBar'
    // ]),
    onRouteChange( to ) {

      log("[layout:calendar] layout update:", to.meta.calendarLayout);
      this.layout_css_class = to.meta.calendarLayout;
      this.$nextTick(() => {
        this.onChangeLayout( to.meta.calendarLayout )
      })

      if ( to.path.startsWith('/calendar') ) {
        log("[layout:calendar] going to a CALENDAR page");
        // this.show_calendar_view_buttons = false;
        this.onSelectView(2);
      } else {
        // this.show_calendar_view_buttons = true;
      }
    },
    onChangeLayout( layout ) {
      this.layout_css_class = layout;

      if ( layout === 'wide' ) {
        this.hide_calendar = false; // HACK
      }
      if ( layout === 'narrow' ) {
        this.hide_calendar = true; // TODO: Save settings in app store
      }

      if ( this.$refs.goalcalendar && this.$refs.goalcalendar.$refs.calendarTopBar ) {
        let onChangeCalendarView = this.$refs.goalcalendar.$refs.calendarTopBar.onChangeCalendarView;
        log("[layout:calendar] setting fullcalendar view:", layout);
        switch (layout) {
          case 'wide':   onChangeCalendarView('agenda', 7, true); break;
          case 'narrow': onChangeCalendarView('agenda', 1, true); break;
        }
        this.last_layout = layout;
      }
    },
    onSelectView(value) {
      this.selected_calendar_view = value;
      if ( this.last_layout !== this.layout_css_class) {
        this.$nextTick(() => {
          this.onChangeLayout( this.layout_css_class )
        });
      }
    },
    onOptimize() {
      // TODO:
    },
  },
  components: {
    Calendar,
    // Sessions,
  }
}
</script>

<style>
.animated-sidebar {
  transition: width 1s ease;
}
.calendar-split-screen {
  /*border: 1px solid blue;*/
  display: flex;
  height: 100vh;
}
.calendar-container {
  /* border: 1px solid red; */
  flex: auto;
  height: calc(100vh - 52px);
  overflow: hidden;
}
.calendar-split-content {
  /* border: 1px solid red; */
  border-left: 1px solid gray;
  width: 350px;
  flex: 0 0 350px;
}
.calendar-split-content.scroll-container {
  /* border: 3px solid red; */
  /* height: calc(100vh - 250px); */
  overflow-y: scroll;
  /*padding: 0.25em 0.5em;*/
}
.calendar-container.narrow {
  width: 300px;
  flex: 0 0 300px; /* TODO */
}
.calendar-split-content.narrow {
  flex: auto;
}
.calendar-split-screen .seperator-button {
  margin: 0;
  padding: 0;
  border-radius: 0;
  background: #d2d2d2;
  color: white;
  border: none;
  font-size: 8pt;
  width: 10px;
}
.calendar-split-screen .seperator-button:hover {
  background-color: #a2a2a2;
}
</style>
